import { TRANSLATION_LANGUAGES } from './translation-language';

export const LANGUAGES_WITH_TRANSLATIONS = TRANSLATION_LANGUAGES;

export type ILanguageWithTranslation = (typeof LANGUAGES_WITH_TRANSLATIONS)[number];
